<template>
  <div
    class="container"
    :class="{is_mirror: isMirror}"
    :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
  >
    <TicketCommon
      v-if="tempTicket"
      ref="tempTicket"
      :class="[showTempTicket ? 'show' : 'hide']"
      :ticket="tempTicket"
    />
    <div class="queues">
      <GroupByOrder name="WAITING" :tickets="waitingTickets" />
      <GroupByOrder name="ASSEMBLING" :tickets="assemblingOrderTickets" />
      <GroupByOrder name="READIED" :tickets="readiedTickets" />
    </div>
    <GroupNoIssued :tickets="commonTickets" />
  </div>
</template>

<script>
import GroupByOrder from '../grouping/GroupByOrder';
import GroupNoIssued from '../grouping/GroupNoIssued';
import TicketCommon from '../tickets/TicketCommon';

import TemplateMixin from '../../mixins/TemplateMixin';

import {TICKET_STATUS} from '../../config';

export default {
  name: 'TemplateIssuing',
  components: {GroupByOrder, GroupNoIssued, TicketCommon},
  mixins: [TemplateMixin],
  props: {
    isMirror: Boolean,
    isAdditionalFrame: Boolean
  },
  computed: {
    commonTickets() {
      return this.items.filter(
        ({window}) => window && 'issuing_point' in window && !window.issuing_point
      );
    },
    waitingTickets() {
      return this.items.filter(({status_type}) => status_type === TICKET_STATUS.WAITING);
    },
    assemblingOrderTickets() {
      return this.items.filter(({window}) => window && window.issuing_point);
    },
    readiedTickets() {
      return this.items.filter(({status_type}) => status_type === TICKET_STATUS.READIED);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.queues {
  display: flex;
  height: 81.485vh;
  border-bottom-style: solid;
  border-bottom-width: max(0.417vw, 8px);
}
</style>
